export default "__VITE_ASSET__BKbuFGoC__"